/**
 * Sitewide Saturday office-hours override. The token is declared (and
 * inline-editable) in the Footer's contentSchema; every other office-hours
 * display reads the same path so one edit updates the whole site.
 */
export const SATURDAY_HOURS_TOKEN = 'footer.saturday_hours';
export const SATURDAY_HOURS_DEFAULT = 'By Appointment Only';
